export default "__VITE_ASSET__BFMPQmn4__"